{
  "add_additional_information": "Добавить дополнительную информацию",
  "conditions": "Условия",
  "count_pending": "{count} в ожидании",
  "create_another_job": "Создать другую вакансию и прикрепить",
  "create_job": "Создать вакансию и прикрепить",
  "creation_request_hiring_plan": "Создание запроса на позицию",
  "editing_request_hiring_plan": "Редактирование запроса на позицию",
  "enter_conditions": "Введите условия",
  "enter_requirements": "Введите требования",
  "enter_responsibilities": "Введите обязанности",
  "hiring_plan": "План найма",
  "hiring_plan_description": "Управляйте запросами вакансий и планом найма",
  "link_another_exist_job": "Прикрепить к другой существующей вакансии",
  "link_exist_job": "Прикрепить к существующей вакансии",
  "link_job": "Прикрепить к вакансии",
  "linked_job": "Связано с вакансией",
  "manage_title": "Управление планом найма",
  "new_employee_required": "Когда требуется новый сотрудник",
  "notification_settings_hiring_plan_caption": "Когда требуется согласование или ответ на запрос",
  "plan_date": "Плановая дата",
  "position": "Позиция",
  "position_request": "Запрос вакансии",
  "position_requests": "Запросы вакансий",
  "request_new_position": "Запросить новую позицию",
  "request_status_hired": "Нанят",
  "request_status_hiring": "В процессе",
  "requirements": "Требования",
  "responsibilities": "Обязанности",
  "select_job": "Выберите вакансию",
  "unlink": "Открепить",
  "view_job": "Посмотреть вакансию",
  "view_request": "Посмотреть запрос",
  "~": "~"
}